/**
 * Returns a reference to the class object of the class specified by the name parameter.
 * @param	name	The name of a class.
 * @return	Returns a reference to the class object of the class specified by the name parameter.
 * @throws	ReferenceError No public definition exists with the
 *   specified name.
 */
/**
 * Returns a reference to the class object of the class specified by the name parameter.
 * @param	name	The name of a class.
 * @return	Returns a reference to the class object of the class specified by the name parameter.
 * @throws	ReferenceError No public definition exists with the
 *   specified name.
 */ export var getDefinitionByName = function (name) {
    //todo
    throw ("getDefinitionByName is not implemented yet in flash/utils");
};
